var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCirclearrowDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_5_33",
    "data-name": "Component 5 \\u2013 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_265",
    "data-name": "Rectangle 265",
    width: 20,
    height: 20,
    transform: "translate(547 3142)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_90",
    "data-name": "Ellipse 90",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 21.5,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Component_4_1",
    "data-name": "Component 4 \\u2013 1",
    transform: "translate(12 12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92",
    transform: "translate(9.899 1.414) rotate(45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_9",
    "data-name": "\\uC120 9",
    d: "M12,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H12a1,1,0,0,1,1,1A1,1,0,0,1,12,1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_10",
    "data-name": "\\uC120 10",
    d: "M0,13a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1,1,1,0,0,1,1,0V12A1,1,0,0,1,0,13Z",
    transform: "translate(12)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_11",
    "data-name": "\\uC120 11",
    d: "M0,12.071a1,1,0,0,1-.707-.293,1,1,0,0,1,0-1.414L10.364-.707a1,1,0,0,1,1.414,0,1,1,0,0,1,0,1.414L.707,11.778A1,1,0,0,1,0,12.071Z",
    transform: "translate(0.929 0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCirclearrowDark);
export default __webpack_public_path__ + "static/media/icon_circlearrow_dark.df98403a235840310bbebe571085999c.svg";
export { ForwardRef as ReactComponent };